//packages
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";
//global components
import MainMenu from "../../_components/MainMenu";
import MainFooter from "../../_components/MainFooter";
import PreLoader from "../../_components/PreLoader";
//services
import { menuService } from "../../_services/menu.service";
import { postService } from "../../_services/post.service";
//styles
import "./Artists.sass";

class Artists extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: {
        details: {},
      },
      menu: {},
      topbarMenu: {},
      // artists: {},
      branches: [],
      nextPage: {},
    };
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user && Date.now() < user.expiresAt) {
      this.setState({
        user: user,
      });
    } else {
      this.setState({
        user: {
          details: {},
        },
      });
    }

    Promise.allSettled([
      postService.getByType("artists", 1, 2).then((artists) => {
        menuService
          .getMenuByName("default")
          .then((menu) => this.setState({ menu, artists: { items: artists} }));
      }),
      menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
      postService.getBranchesFooter('branch').then(branches => this.setState({ branches }))
    ]).then(() => this.setState({ loading: false }));

    window.addEventListener("scroll", this.getNextPage);
  }

  componentWillUnmount() {
    // you need to unbind the same listener that was binded.
    window.removeEventListener('scroll', this.getNextPage);
  }
  
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.artists && this.state.artists.items) {
      return JSON.stringify(this.state.artists.items) === JSON.stringify(nextState.artists.items);
    }

    return true;
  }

  getTextValue = (html) => {
    if (html) {
      var span = document.createElement("span");
      span.innerHTML = html;
      // let getHtml = html.replace(/<p[^>]*>/g, "<p>");

      //if the value contains <p>
      const getPTag = span.getElementsByTagName("p")[0].innerText;
      //get all text content in elements
      const getText = span.textContent || span.innerText;

      return getPTag + "..." || getText.substr(0, 260) + "...";
    } else {
      return false;
    }
  };

  getNextPage = () => {
    const {artists} = this.state;
    var getId = document.getElementById("loadingPage");

    if(artists && artists.items && getId){
      var nextArtists;
      //get dimensions outside element
      var getLoad = getId.getBoundingClientRect();
      var elemTop = getLoad.top;
      var elemBottom = getLoad.bottom;
  
      // Only completely visible elements return true:
      var loadVisible = elemTop >= 0 && elemBottom <= window.innerHeight;
      // Partially visible elements return true:
      //isVisible = elemTop < window.innerHeight && elemBottom >= 0;

      if(loadVisible && artists.page + 1 <= (artists.total / artists['per-page']) + (artists.total % artists['per-page'])){
        return postService.getByType("artist", artists.page + 1, artists['per-page']).then((NextArtists) => {
          if(!nextArtists){
            nextArtists = NextArtists && NextArtists.items
            this.setState({
              artists: {
                ...NextArtists,
                items: artists.items.concat(nextArtists)
              }
            })
          }
          })
      }else{
        return false
      }
    }
  };

  render() {
    const { loading, user, menu, topbarMenu, artists, branches } = this.state;
  
    return (
      <>
      <PreLoader loading={loading} />
      <MainMenu user={user} menu={menu} topbarMenu={topbarMenu} />
      <div className="jumbotron page-title py-5">
        <div className="container">
          <h1 className="text-white">KORG Artists</h1>
        </div>
      </div>
        {artists &&
        <section className="main-content">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb bg-transparent m-0">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Artists
                    </li>
                  </ol>
                </nav>
                <hr className="m-0 mb-4" />
              </div>
            </div>

            {artists && artists.items && (
              <>
                <div className="row">
                  {artists.items.sort((a,b) => { return a.id - b.id }).map((artist,index) => (
                    <div className="col-sm-12 col-md-6 col-lg-6 mb-5" key={index}>
                      <div className="card mb-3 h-100">
                        <img className="card-img-top" src={artist.acf.image ? artist.acf.image : ""} alt="..." />
                        <div className="card-body">
                          <h5 className="card-title">{artist.title.rendered}</h5>
                          <p className="card-text">{this.getTextValue(artist.content.rendered)}</p>
                        </div>
                        <div className="card-footer">
                          <a
                            className="btn btn-primary btn-sm"
                            href={"/artists/" + artist.slug}
                            role="button"
                          >
                            Read Artist Info
                            <FontAwesomeIcon icon={faLongArrowAltRight} />
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {artists && artists.total > artists.items.length &&
                  <div id="loadingPage" style={{display: 'block'}}></div>
                }
              </>
            )}



          </div>
        </section>
        }
        <MainFooter menu={menu} branches={branches} />
      </>
    );
  }
}

export { Artists };
